// Import here Polyfills if needed. Recommended core-js (npm i -D core-js)
// import "core-js/fn/array.find"
// ...

export class Token {
  constructor(
    public type: string,
    public value: string = '',
    public data: { [key: string]: string } = {}
  ) {}
}

export class Rule {
  constructor(public type: string, public pattern: RegExp) {}
}

export default class Lexer {
  private i: number = 0
  private input: string = ''

  constructor(private rules: Rule[]) {}

  lex(input: string): Token[] {
    this.input = input
    this.i = 0
    const tokens: Token[] = []

    let next = this.nextToken()
    while (this.i <= input.length) {
      if (tokens.length > 0 && tokens[tokens.length - 1].type === 'text' && next.type === 'text') {
        tokens[tokens.length - 1].value += next.value
      } else if (next.type === 'whitespace') {
      } else {
        tokens.push(next)
      }
      next = this.nextToken()
    }
    return tokens
  }

  nextToken(): Token {
    for (let rule of this.rules) {
      const result = rule.pattern.exec(this.leftover)
      if (result != null) {
        const groups = result.groups ? result.groups : {}
        const value = result.groups ? result.groups.v : ''
        this.take(result[0].length)
        return new Token(rule.type, value, groups)
      }
    }

    const match = /^([\n|\r])/.exec(this.leftover)
    if (match != null) {
      return new Token('whitespace', this.take(match[0].length))
    }

    return new Token('text', this.take(1))
  }

  get leftover(): string {
    return this.input.slice(this.i)
  }

  take(n: number): string {
    this.i += n
    return this.input.slice(this.i - n, this.i)
  }
}
